import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import SimpleSelect from '../SimpleSelect';

const EditCustomerModal = (props) => {
    const [name, setName] = useState(props.name);
    const [levelZero, setLevelZero] = useState(props.levelZero);
    const [isActive, setIsActive] = useState(props.isActive);
    const [loading, setLoading] = useState(false);

    const { open, onClose, saveClick, action } = props;

    const handleSave = async () => {
        setLoading(true);
        const payload = {
            name: name,
            level_0: levelZero,
            is_active: isActive,
            lastUpdated: new Date(),
        };
        await saveClick(payload);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle>
                {action === 'new' ? 'New Customer' : 'Edit Customer Page'}
            </DialogTitle>
            <DialogContent>
                <div>
                    <TextField
                        label="Customer Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={{ width: 300, marginBottom: 15 }}
                    />
                </div>
                <div>
                    <TextField
                        label="Level 0"
                        value={levelZero}
                        onChange={(e) => setLevelZero(e.target.value)}
                        style={{ width: 300, marginBottom: 15 }}
                    />
                </div>
                <div>
                    <SimpleSelect 
                            title="Is Active"
                            onChange={(e) => setIsActive(e)}
                            defaultValue={isActive}
                            options={
                                [
                                    { label: 'Active', value: true, key: 'active' }, 
                                    { label: 'InActive', value: false, key: 'inactive' }
                                ]
                            }
                        />
                </div>
            </DialogContent>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: 20 }}>
                <Button onClick={onClose} color="primary" variant="outlined">
                    Close
                </Button>
                <Button 
                    onClick={handleSave} 
                    color="primary" 
                    variant="outlined"
                    disabled={!name || !levelZero || loading}
                >
                    {action === 'new' ? 'Add Customer' : 'Save Edits'}
                </Button>
            </div>
        </Dialog>
    );
};

export default EditCustomerModal;
